import React from 'react'
import { useTranslation } from 'react-i18next'

import Script from 'dangerous-html/react'

import './contact-form-embed.css'

const ContactFormEmbed = () => {
  const { t } = useTranslation()

  return (
    <section id="contact" className="contact-form-section">
      <div className="contact-form-container">
        <div className="contact-form-header">
          <h2 className="section-title">{t('contact.title')}</h2>
          <p className="section-subtitle">{t('contact.subtitle')}</p>
        </div>
        <div className="contact-form-wrapper">
          <div
            className="formrun-embed"
            data-formrun-form="@yh-4Ym1K6kriGJX9yVxYvoD"
            data-formrun-redirect="true"
          ></div>
          <Script
            html={`<script src="https://sdk.form.run/js/v2/embed.js"></script>`}
          ></Script>
        </div>
      </div>
    </section>
  )
}

export default ContactFormEmbed
